export default class SaveMassProductRequest {
    public massProductId: string | null = null;

    public productGroupId: string = "";

    public productType: string | null = null;
}